import { render } from "./selectMs.vue?vue&type=template&id=8b4e78da"
import script from "./selectMs.vue?vue&type=script&lang=js"
export * from "./selectMs.vue?vue&type=script&lang=js"

import "./selectMs.vue?vue&type=style&index=0&id=8b4e78da&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__